<template>
  <img
    :src="src"
    :alt="alt"
    @error="(e) => {e.target.src='/img/avatar.png'}"
  >
</template>

<script>
export default {
  name: 'XImage',
  props: {
    src: {
      type: [String, null],
      required: true
    },
    alt: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
